
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';


import './contactus.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pcontactus = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {





	function function_redirigircontactanos_69461aeb8e5aed52dc8d5c28() {
		history.push("https://wa.me/50487475208");
	}


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be768" >

      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/soluciones"
        type=""
      >
        <>Soluciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobregrowth"
        type=""
      >
        <>Sobre Growth</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/casosdeexito"
        type=""
      >
        <>Casos de Éxito</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
        <a
          target=""
          className=""
          id="i1t9kk"
          href="/"
        >
          
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjaas9j1.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href="/soluciones"
        >
          
    <div id="iye9" className="">
    <>SOLUCIONES</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href="/sobregrowth"
        >
          
    <div id="i8s6k" className="">
    <>SOBRE GROWTH</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href="/casosdeexito"
        >
          
    <div id="ib721" className="">
    <>CASOS DE ÉXITO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>BLOG</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactanos"
        >
          
    <div id="ii21f" className="">
    <>CONTACTO</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="izen5f" className="">
      <>
        </>
      </div>
      
      <div
        id="iboh0t"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ihs61j" className="">
      
      <div id="iq87mx" className="">
      
      <img
        className=""
        id="i7koxz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgts6ivs.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i8da6x"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="iqz3um" className="">
      
      <div id="i0qfqs" className="">
      
      <div id="ic0wri" className="">
      
      <div className="" id="iqpor3">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="ilkh7">
        <>¡Hablemos de tu estrategia de marketing!</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      
      <div className="" id="ijzgei">
        <>Teléfono: &#40;+504) 0000-0000</>
      <br className="" id="" />
      <>WhatsApp: &#40;+504) 0000-0000</>
      <br className="" id="" />
      <>Correo: contacto@tusitio.com</>
      <br className="" id="" />
      <>Dirección: Calle/Colonia, Ciudad, País &#40;si aplica)</>
      <br className="" id="" />
      <>Horario: Lun–Vie 8:00–17:00, Sáb 9:00–12:00</>
      </div>
      
      <div id="isi44z" className="">
      
        <a
          target=""
          className=""
          id="ijbkf1"
          href="https://wa.me/50487475208"
        >
          
      <span className="" id="iyp7hm">
        <>Escríbenos por WhatsApp</>
      </span>
      
      <img
        className=""
        id="ia75iu"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjafo5a1.png"
        alt="undefined"
      />
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iadiwu" className="">
      
        <div className="" id="i1365f">
          
      <form
        id="ir0hwk"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
				} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div className="" id="i30acj">
        
      <span className="" id="i5n6ha">
        <>O también puedes contactarnos aquí</>
      </span>
      
      </div>
      
      <div id="it6izf" className="">
      
      <br className="" id="" />
      
      <input
        name="nombre"
        type="text"
        placeholder="nombre"
        className=""
        id="izfilk"
      />
      
      </div>
      
      <div id="i6zm28" className="">
      
      <br className="" id="" />
      
      <input
        name="correo"
        type="text"
        placeholder="correo"
        className=""
        id="ir9d6z"
      />
      
      </div>
      
      <div id="ih3lgi" className="">
      
      <br className="" id="" />
      
      <input
        name="asunto"
        type="text"
        placeholder="asunto"
        className=""
        id="ivgkaa"
      />
      
      </div>
      
    <div id="ijkhyk" className="">
    
      <br className="" id="" />
      
      <textarea name="mensaje" className="" id="imcshj">
        
      </textarea>
      
    </div>
    
      <button
        type="submit"
        name=""
        id="i1tk4l"
        className=""
        
      >
      
      <div id="icxs0s" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        onClick={async () => {
		function_redirigircontactanos_69461aeb8e5aed52dc8d5c28();
}}

      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		function_redirigircontactanos_69461aeb8e5aed52dc8d5c28();
}}

      >
      
      <div id="ih6ehn" className="">
      <>Agenda una cita</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iq7h1i" className="">
      
      <div id="iofzsc" className="">
      
      <img
        className=""
        id="iqxhxm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjaas9j1.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iu1mvh" className="">
      
      <div id="izh2yk" className="">
      
      <div className="" id="ikvqtj">
        <>1234 Pais, Ciudad, Depto,</>
      <br className="" id="" />
      <> CA</>
      </div>
      <>
        </>
      </div>
      
      <div id="iukbti" className="">
      
      <div className="" id="ijbv1t">
        <>+504 123456789</>
      </div>
      <>
        </>
      </div>
      
      <div id="igc723" className="">
      
      <div className="" id="imxlgb">
        <>info@marketingdigital.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ikr6m9" className="">
      
        <a
          target=""
          className=""
          id="ill85u"
          href="/"
        >
          
      <div className="" id="iigfy4">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="if6k8i"
          href="/soluciones"
        >
          
      <div className="" id="iay6kj">
        <>Soluciones</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i5hbc7"
          href="/sobregrowth"
        >
          
      <div className="" id="i0px9r">
        <>Sobre Growth</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ioq3np"
          href="/casosdeexito"
        >
          
      <div className="" id="imv2py">
        <>Casos de Éxito</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ivpvbp"
          href="/portfolio"
        >
          <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ir1e6f"
          href="/blog"
        >
          
      <div className="" id="i1a87s">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iqs5xj"
          href="/contactanos"
        >
          
      <div className="" id="i9hyfg">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4svkw" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjam6dd7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025 Growth Holístico. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="ic61xj"
          href="https://wa.me/50487475208"
        >
          
      <img
        className=""
        id="itijyb"
        src="https://assetsprojects.s3.amazonaws.com/405gznimll0fka3.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactus);
  